module.exports = __webpack_public_path__ + "img/chapter-1.ae3eb7b4.png";